import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const carDetailsApi = createApi({
  reducerPath: reducerPaths.carDetailsApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    vehicleOfferPrice: builder.query({
      query: ({ storedVehicleId, 
        params,
        vin, mileage, trim, year, make, model 
      }) => {
        return {
          url: `/seller/vehicleofferprice/${storedVehicleId}`,
          method: 'GET',
          params
        }
      }
    }),
    getLiveAuctionTimer: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/timeoutdetails/${vehicleId}`,
        };
      },
    }),
    getAgentDetails: builder.query({
      query: ({ vehicleId }) => {
        return `agent/agentdetails/${vehicleId}`;
      },
    }),
    getVehicleDetails: builder.query({
      query: ({ vehicleId }) => `/seller/vehicle/${vehicleId}`,
    }),
    getSellerDetails: builder.query({
      query: ({ vehicleId }) => {
        return {
          url: `/seller-detail/${vehicleId}`,
          method: 'GET'
        }
      },
    }),
  }),
});

export const {
  useVehicleOfferPriceQuery,
  useGetLiveAuctionTimerQuery,
  useGetAgentDetailsQuery,
  useGetVehicleDetailsQuery,
  useGetSellerDetailsQuery,
  useLazyGetVehicleDetailsQuery,
  useLazyGetLiveAuctionTimerQuery,
  useLazyGetAgentDetailsQuery,
  useLazyVehicleOfferPriceQuery,
  useLazyGetSellerDetailsQuery,
} = carDetailsApi;
